import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ApproveUserPage = () => {
  const darkMode = localStorage.getItem("darkMode") === "true";
  const location = useLocation();
  const navigate = useNavigate();
  const username = location.pathname.split("/")[2];

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const approveUser = async () => {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/approve-user/${username}`,
          {}
        );
        setSuccess(true);
      } catch (err) {
        setError("Failed to approve user. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    approveUser();
  }, [username]);

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: darkMode ? "#1D1E21" : "#F5F5F5",
        color: darkMode ? "#fff" : "#000",
      }}
    >
      {loading ? (
        <Box textAlign="center">
          <CircularProgress size={80} thickness={4} />
          <Typography variant="h5" mt={3}>
            Approving user...
          </Typography>
        </Box>
      ) : success ? (
        <Box textAlign="center">
          <CheckCircleOutlineIcon sx={{ fontSize: 100, color: "#4caf50" }} />
          <Typography variant="h4" mt={2} mb={1}>
            You approved the {username} user successfully!
          </Typography>
          <Typography variant="body1">
            New User has been successfully approved.
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 4, fontSize: 18, px: 5, py: 1.5 }}
            onClick={handleBackToLogin}
          >
            Back to Login
          </Button>
        </Box>
      ) : (
        <Box textAlign="center">
          <ErrorOutlineIcon sx={{ fontSize: 100, color: "#f44336" }} />
          <Typography variant="h4" mt={2} mb={1}>
            Approval Failed
          </Typography>
          <Typography variant="body1">{error}</Typography>
          <Button
            variant="contained"
            sx={{ mt: 4, fontSize: 18, px: 5, py: 1.5 }}
            onClick={handleBackToLogin}
          >
            Back to Login
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ApproveUserPage;
